<template>
  <div>
    <v-dialog scrollable max-width="1200" v-model="model" persistent>
      <v-card v-if="loading">
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
      <div v-else>
        <material-card
        :title="$t('components.memberview.viewedit_file')"
          :color="$vuetify.theme.themes.light.secondary"
          icon="contact_page"
        >
          <v-card-text style="max-height:400px;overflow:scroll">
            <span v-if="provider === undefined || provider === null">
              {{ $t("components.memberfiles.no_items_message") }}
            </span>
            <pbas-data-table
              v-else
              ref="table"
              :dataProvider="provider"
              fileNamePrefix="Files"
              :rowActions="rowActions"
              identifier="FilesTable"
              :selectActions="selectActions"
            ></pbas-data-table>
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="$emit('close')">
              {{ $t("globals.close") }}
            </v-btn>
          </v-card-actions>
          <v-dialog scrollable max-width="1000" v-model="edit">
            <material-card
            :title="$t('components.memberfiles.replace')"
              :color="$vuetify.theme.themes.light.primary"
              icon="swap_horiz"
            >
              <v-card-text>
                <v-form ref="form">
                  <v-row row no-gutters class="flex-nowrap" align="center">
                    <v-col xs12 sm12 md8 lg6>
                      <single-file-upload2
                        id="replaceFileId"
                        @emit-upload-start="saving = true"
                        @emit-upload-end="saving = false"
                        :label="$t('components.memberfiles.replace_file')"
                        :tags="[selectedPlan.UniqueIdentifier]"
                        :categories="['Enrolment']"
                        :currentFolder="selectedPlan.Name"
                        :zipDownloadUrl="
                          settings.DOCUMENTSERVICEURL + 'api/ZipFilesDownload'
                        "
                        :fileUploadUrl="
                          settings.DOCUMENTSERVICEURL + 'api/UploadFiles'
                        "
                        @emit-files="
                          bindFile($event);
                          saving = false;
                        "
                        @emit-upload-error="
                          error = $event;
                          saving = false;
                        "
                      />
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn text @click="close">
                  {{ $t("globals.close") }}
                </v-btn>
                <v-btn
                  color="primary"
                  :loading="saving"
                  @click="save"
                  :disabled="newId === null || newId === undefined"
                >
                  {{ $t("globals.save") }}
                </v-btn>
              </v-card-actions>
            </material-card>
          </v-dialog>
          <file-preview :fullScreen="true" v-if="view" :view="view" :fileItem="fileItem" @close="close"/>
          <v-dialog
            scrollable
            v-if="selectedPlan"
            v-model="shareDialog"
            persistent
            max-width="900"
          >
            <share-member-files
            v-if="shareDialog"
              :brokerId="selectedPlan.BrokerId"
              :planId="selectedPlan.Id"
              @closeDialog="(e) => (shareDialog = e)"
              :fileIds="checkedFiles.map(o=>o.Id)"
              :maxDataRetrieved="10"
            />
          </v-dialog>
          <v-container
            v-if="printfile !== null && printfile !== undefined"
            v-show="false"
          >
            <v-sheet color="white" outlined id="print">
              <v-row style="height: auto;">
                <v-col
                  v-if="src && printfile.FileType === 'Image'"
                  align-self="center"
                >
                  <v-img ref="img" :src.sync="src"></v-img>
                </v-col>
                <v-container
                  v-else-if="src && printfile.FileType === 'Adobe Reader'"
                >
                  <v-row v-if="!fullscreen">
                    <v-col
                      class="col-4"
                      v-show="!hideSidebar"
                      align-self="center"
                    >
                      <v-list outlined>
                        <v-list-item v-for="page in pageCount" :key="page">
                          <v-tooltip
                            :color="
                              tooltipBackgroundColor
                                ? tooltipBackgroundColor
                                : 'blue-grey lighten-2'
                            "
                            left
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-row
                                @click="goToPage(page)"
                                v-bind="attrs"
                                v-on="on"
                              >
                                <pdf :page="page" :src.sync="pdfSrc"></pdf>
                              </v-row>
                            </template>
                            <span
                              :style="
                                tooltipTextHexColor
                                  ? `color: ${tooltipTextHexColor};`
                                  : 'color: white;'
                              "
                            >
                              {{
                                $t("download_center.labels.go_to_page") + page
                              }}
                            </span>
                          </v-tooltip>
                        </v-list-item>
                      </v-list>
                    </v-col>
                  </v-row>

                  <v-col align-self="center" v-if="fullscreen">
                    <pdf
                      v-for="page in pageCount"
                      :key="page"
                      :src.sync="pdfSrc"
                      :page="page"
                    ></pdf>
                  </v-col>
                </v-container>

                <v-col
                  v-else-if="src && printfile.FileType === 'text'"
                  align-self="center"
                  class="pa-10"
                >
                  <v-sheet ref="text" class="pa-4" outlined :light="false">
                    {{ src }}
                  </v-sheet>
                </v-col>
                <v-col v-else class="pa-10">
                  <v-sheet
                    class="pa-4 ma-0 text-center"
                    outlined
                    :light="false"
                  >
                    <h5>{{ $t("download_center.labels.no_preview") }}</h5>
                  </v-sheet>
                </v-col>
              </v-row>
            </v-sheet>
          </v-container>
          <v-dialog scrollable v-model="loadingFile" persistent max-width="200">
            <v-card>
              <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
              <v-card-text>
                <v-container fluid grid-list-md>
                  <v-layout row justify-center>
                    <v-flex xs12 sm6 md4 lg3>
                      <v-progress-circular indeterminate></v-progress-circular>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
        </material-card>
      </div>
    </v-dialog>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import { InMemoryProvider } from "pbas-vue-components";
import InMemoryFileHeaders from "../headers/InMemoryFiles";
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import { saveAs } from "file-saver";
import printJS from "print-js";
import pdf from "vue-pdf";
import SingleFileUpload2 from "../components/SingleFileUpload2";
import FilePreview from './FilePreview.vue';
import ShareMemberFiles from "../components/ShareMemberFiles.vue";

export default {
  name: "member-files",
  props: ["model", "memberIdentityId", "planId"],
  components: { ErrorHandler, pdf, SingleFileUpload2, FilePreview, ShareMemberFiles },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("common", ["settings"]),
  },
  data() {
    return {
      shareDialog: false,
      fileItem: null,
      loadingFile: false,
      tooltipBackgroundColor: null,
      tooltipTextHexColor: null,
      pdfSrc: null,
      pageCount: 0,
      fullscreen: false,
      hideSidebar: true,
      printfile: null,
      src: null,
      fileData: null,
      file: null,
      view: false,
      saving: false,
      newId: null,
      newName:null,
      filesIds: [],
      loading: false,
      error: null,
      edit: false,
      provider: undefined,
      rowActions: [
        {
          name: "edit",
          icon: "swap_horiz",
          title: "components.memberfiles.replace",
          handler: (item) => {
            this.filesIds = [item.Id];
            this.edit = true;
          },
        },
        {
          name: "view",
          icon: "visibility",
          title: "globals.view",
          handler: (item) => {
            this.viewFile(item);
          },
          visible: (item) => {
            console.log(item);
            return (
              item.FileType === "Adobe Reader" ||
              item.FileType === "Image" ||
              item.FileType === "text"
            );
          },
        },
        {
          name: "print",
          icon: "print",
          title: "globals.print",
          handler: (item) => {
            this.printFile(item);
          },
          visible: (item) =>
            item.FileType === "Adobe Reader" ||
            item.FileType === "Image" ||
            item.FileType === "text",
        },
        {
          name: "download",
          icon: "file_download",
          title: "globals.download",
          handler: (item) => {
            this.tryDownloadFile(item);
          },
        },
        {
          name: "shareFile",
          icon: "share",
          title: "globals.share",
          handler: (item) => {
            this.checkedFiles = [item];
            this.shareDialog = true;
          },
        },
      ],
      selectActions: [
        {
          name: "downloadFiles",
          icon: "file_download",
          title: "globals.download",
          handler: (item) => {
            this.checkedFiles = item;
            this.downloadFiles();
          },
        },
        {
          name: "shareFile",
          icon: "share",
          title: "globals.share",
          handler: (item) => {
            this.checkedFiles = item;
            this.shareDialog = true;
          },
        },
      ],
      headers: InMemoryFileHeaders,
      checkedFiles: [],
    };
  },
  watch: {
    model: {
      handler(v) {
        // console.log(v);
        if (v) {
          this.loadData();
        } else {
          this.provider = undefined;
        }
      },
    },
  },

  methods: {
    ...mapActions("plansMembers", ["getMemberFiles", "replaceMemberFile"]),
    ...mapActions("documentsService", ["getFile", "downloadFile"]),
    
    async viewFile(item) {
      this.fileItem = item;
      this.view = true;
    },
    async tryDownloadFile(item) {
      try {
        this.loadingFile = true;
        const file = (await this.getFile(item.Id)).data;
        const blob = this.$files.b64toBlob(file);
        console.log(item);
        this.loadingFile = false;
        saveAs(blob, item.FileName);
      } catch (error) {
        this.error = error;
      }
    },
    async downloadFiles() {
      this.loadingFile = true;
      const ids = this.checkedFiles.map(o=>o.Id);
      try {
        const res = (await this.downloadFile({ids:ids})).data;
        // const blob = window.URL.createObjectURL(
        //   new Blob([base64ToArrayBuffer(res)])
        // );
        const blob = this.$files.b64toBlob(res);
        const name =
          ids.length > 1
            ? "files.zip"
            : this.checkedFiles[0].FileName;
        saveAs(blob, name);
      } catch (error) {
        this.error = error;
      } finally {
        this.loadingFile = false;
      }
    },
    async printFile(item) {
      try {
        this.loadingFile = true;
        const file = (await this.getFile(item.Id)).data;
        const blob = this.$files.b64toBlob(file);

        const fileData = new File([blob], item.FileName, {
          type: blob.type,
        });

        if (item.FileType === "text") {
          this.src = await this.readFileAsTextAsync(fileData);
        } else if (
          item.FileType === "Adobe Reader" ||
          item.FileType === "Image"
        ) {
          this.src = await this.readFileAsDataUrlAsync(fileData);
        }

        this.printfile = item;
        this.loadingFile = false;

        this.$nextTick(() => {
          const objectURL = URL.createObjectURL(fileData);
          const pagestyle =
            "@page { size: A4; margin-top: 0mm; margin-bottom: 0mm;} body {margin: 0;} h4 {margin:0}";
          if (item.FileType === "Image") {
            printJS({
              printable: objectURL,
              type: "image",
              header: item.FileName,
              imageStyle: "width: 100%",
              headerStyle: "font-weight: 300;",
              style: pagestyle,
              targetStyles: ["*"],
            });
          } else if (item.FileType === "Adobe Reader") {
            printJS({
              printable: objectURL,
              type: "pdf",
            });
          } else {
            printJS({
              printable: "print",
              type: "html",
              header: item.FileName,
              headerStyle: "font-weight: 300;",
              style: pagestyle,
              targetStyles: ["*"],
            });
          }
        });
      } catch (error) {
        this.error = error;
      }
    },
    readFileAsTextAsync(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onload = () => {
          resolve(reader.result);
        };

        reader.onerror = reject;

        reader.readAsText(file);
      });
    },
    readFileAsDataUrlAsync(file) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();

        reader.onload = () => {
          resolve(reader.result);
        };

        reader.onerror = reject;

        reader.readAsDataURL(file);
      });
    },
    async save() {
      try {
        this.saving = true;
        await this.replaceMemberFile({
          planId: this.selectedPlan.Id,
          memberId: this.memberIdentityId,
          payload: {
            NewFileId: this.newId,
            OldFileId: this.filesIds[0],
            Name: this.newName
          },
        });
        this.edit = false;
        this.loadData();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    bindFile(files) {
      console.log(files);
      this.newId = files.file.Id;
      this.newName= files.file.Name;
    },
    async loadData() {
      try {
        this.loading = true;
        let items = (await this.getMemberFiles({
          planId: this.selectedPlan.Id,
          memberId: this.memberIdentityId,
        })).data;
        if (items.length > 0) {
          this.provider = new InMemoryProvider(items, this.headers);
        }
      } catch (error) {
        this.error = error;
      }
      this.loading = false;
      // this.edit = true
    },
    close() {
      this.edit = false;
      this.view = false;
      this.file = null;
      this.fileItem = null;
    },
  },
};
</script>
<style>
.centered-div {
  margin-left: auto;
  margin-right: auto;
}
</style>
